import { ButtonType, ButtonWidget, DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages } from '~src/codegen/Localize';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { AddNodeDialogProps, GetAddNodeDialogWidget,GetAddNodeFooterContent} from '~src/settings/dataconnect-settings/sections/dataConnectMultiCluster/AddNodeDialog';
import { cssClass } from '~src/style';

import { Cluster } from '../types/Cluster';

export interface AddNodeButtonProps {
  cluster: Cluster;
  siteId: string;
}


export function AddNodeButton(props: AddNodeButtonProps) {
  return (
    <span className={'tb-data-grid-icon tb-padded-left-small'} data-tb-test-id={'cluster-actions-menu-cell'}>
        <ButtonWidget
          testId={'cluster-add-node-script'} buttonType={ButtonType.Outline}
          onClick={() => openAddNodeDialog(props.cluster, props.siteId)}
          style={{ paddingRight:3,  paddingLeft:5, borderColor:'transparent'}}
          disabled={!props.cluster.allowGetInstallFile}
        >
          <img src={imgPath('plus_14px-small.svg')} alt={''} className={addNodeIconClass} />
          <span>{Messages.dataConnectSiteSettingsGenerateNodeScriptButton()}</span>
        </ButtonWidget>
    </span>
  );
}

function openAddNodeDialog(cluster: Cluster, siteId: string) {
  return Promise.resolve(openAddNodeReactDialog(cluster.clusterId, cluster.displayName, siteId));
}

function openAddNodeReactDialog(clusterId: string, clusterName: string, siteId: string) {

  ReactModalService.openCustom(closeAndDismiss => {
    const props: AddNodeDialogProps = {
                        descriptionPart1: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionPart1(),
                        descriptionPart2: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionPart2(),
                        descriptionPart3: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionPart3(),
                        cammandLine1: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionCommand1(),
                        cammandLine2: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionCommand2(),
                        cammandLine3: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionCommand3(),
                        cammandLine4: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionCommand4(),
                        cammandLine5: Messages.dataConnectSiteSettingsClusterAddNodeDescriptionCommand5(),
      dismiss: closeAndDismiss.dismiss
    };
    const dialogProps = ReactModalService.getDefaultDialogProps({
      type: DialogType.NormalWithTitleBar,
      title: Messages.dataConnectSiteSettingsPoolAddNewNodeToPool(({ CLUSTER_NAME: clusterName })),
      testId: 'dataconnect-add-node-dialog',
      showCloseButton: true,
      positioningBehavior: DialogPositioningBehavior.Centered,
      dialogWidth: TabDialogWidth.width375px,
      footerContent: GetAddNodeFooterContent(props, clusterId, siteId)
    }, closeAndDismiss);
    return GetAddNodeDialogWidget(dialogProps, props);
  }).result.finally(() => {});
}

const addNodeIconClass = cssClass('add-node', 'icon', {
  verticalAlign: 'middle',
  paddingRight: 3
});

const innerContainerStyle = style({
  width: 700,
  paddingLeft: 85,
  display: 'flex',
});